import { Component, Input } from '@angular/core';

import { IDateOfServiceMinMax } from '@assess/shared/entities';

import { AbstractFormComponent } from '../abstract-form.component';

@Component({
  selector: 'assess-date-of-service',
  templateUrl: './date-of-service.component.html',
  styleUrls: ['./date-of-service.component.scss'],
})
export class DateOfServiceComponent extends AbstractFormComponent {
  @Input() dateOfServiceMinMax!: IDateOfServiceMinMax;
}
